import _ from 'lodash';
import i18n from "../../../shared/i18n";
import {store} from "@/plugins/vuex";
import FeatureRequestSearchModel from "@/modules/feature-request/FeatureRequestSearch.model";
import FeatureRequestService from "@/modules/feature-request/FeatureRequestService";
import {FEATURE_REQUEST_TABLE_NAME, SOURCE_FEATURE_REQUEST_TABLE} from "@/modules/constants";
import cloneDeep from "lodash/cloneDeep";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new FeatureRequestSearchModel(),
    extraFilters: {},
    expand: 'total_comments',
    toggleColumns: {
      fields: [...getDefaultTableFields(), ...differentFields],
      requiredFields: ['no', 'title'],
      defaultFields: ['no', 'title', 'created_at', 'updated_at', 'priority', 'module_name', 'status', 'dev_status', 'price'],
    }
  }
};

let getDefaultTableFields = () => {
  return [
    {
      key: 'no',
      label: i18n.t('No'),
      sortable: true,
      tdClass: 'no_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'title',
      label: i18n.t('Title'),
      sortable: true,
      tdClass: 'title_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'priority',
      label: i18n.t('Priority'),
      sortable: true,
      tdClass: 'priority_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'module_name',
      label: i18n.t('Module'),
      sortable: true,
      tdClass: 'module_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'status',
      label: i18n.t('Status'),
      sortable: true,
      tdClass: 'status_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'dev_status',
      label: i18n.t('Dev. Status'),
      sortable: true,
      tdClass: 'dev_status_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'description',
      label: i18n.t('Description'),
      sortable: true,
      tdClass: 'description_col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'created_at',
      label: i18n.t('Created at / Created by'),
      sortable: true,
      tdClass: 'created-data-col',
      isVisible: true,
      expand: 'created_by'
    },
    {
      key: 'updated_at',
      label: i18n.t('Updated at / Updated by'),
      sortable: true,
      tdClass: 'updated-data-col',
      isVisible: true,
      expand: 'updated_by'
    },
    {
      key: 'price',
      label: i18n.t('Price'),
      isVisible: true
    },
    {
      key: 'payment_status',
      label: i18n.t('Payment'),
      isVisible: true
    },
    {
      key: 'actions',
      label: i18n.t('Actions'),
      sortable: false,
      tdClass: 'actions-col',
      isVisible: true,
      expand: ''
    },
  ]
}

export default {
  namespaced: true,
  state: {
    modal: {
      show: false,
      object: null,
      source: null
    },
    commentsModal: {
      show: false,
      featureRequest: null,
      source: null
    },
    tableSource: null,
    tableData: {
      featureRequest: getDefaultTableData(),
    },
    statuses: [
      {key: i18n.t('Under review'), value: 'under_review'},
      {key: i18n.t('Outstanding Comments'), value: 'outstanding_comments'},
      {key: i18n.t('Invoice Issued'), value: 'invoice_issued'},
      {key: i18n.t('Invoice Paid'), value: 'invoice_paid'},
      {key: i18n.t('Rejected'), value: 'rejected'},
    ],
    devStatuses: [
      {key: i18n.t('In Development'), value: 'in_development'},
      {key: i18n.t('In QA'), value: 'in_qa'},
      {key: i18n.t('Released on Live'), value: 'released_on_live'},
    ],
    paymentStatuses: [
      {key: i18n.t('Paid'), value: 'paid'},
      {key: i18n.t('Unpaid'), value: 'unpaid'},
    ],
    priorities: [
      {key: i18n.t('Low'), value: 'low'},
      {key: i18n.t('Medium'), value: 'medium'},
      {key: i18n.t('High'), value: 'high'},
    ],
    modulesNames: [
      {key: i18n.t('Customer'), value: 'customer'},
      {key: i18n.t('Receipts'), value: 'receipts'},
      {key: i18n.t('Inventory'), value: 'inventory'},
      {key: i18n.t('Temporary Inventory'), value: 'temporary_inventory'},
      {key: i18n.t('Auction Management'), value: 'auction_management'},
      {key: i18n.t('Lot Management'), value: 'lot_management'},
      {key: i18n.t('Lot-up Process'), value: 'lot_up_process'},
      {key: i18n.t('Exports'), value: 'exports'},
      {key: i18n.t('Reports'), value: 'reports'},
      {key: i18n.t('Notifications'), value: 'notifications'},
      {key: i18n.t('Auction Result Management'), value: 'auction_result_management'},
      {key: i18n.t('Bidders'), value: 'bidders'},
      {key: i18n.t('Bids'), value: 'bids'},
      {key: i18n.t('Commission & Telephone Bids'), value: 'commission_telephone_bids'},
      {key: i18n.t('Buyer Invoices'), value: 'buyer_invoices'},
      {key: i18n.t('Vendor Settlements'), value: 'vendor_settlements'},
      {key: i18n.t('Condition Reports'), value: 'condition_reports'},
      {key: i18n.t('Marketing'), value: 'marketing'},
    ]
  },
  actions: {
    showModal({commit}, {object = {}, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    showCommentsModal({commit}, payload) {
      commit('showCommentsModal', payload);
    },
    hideCommentsModal({commit}) {
      commit('hideCommentsModal');
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new FeatureRequestSearchModel({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await FeatureRequestService.getFeatureRequests(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${FEATURE_REQUEST_TABLE_NAME}.${state.tableSource}`
      })

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async createFeatureRequest({dispatch, state}, data) {
      let response = await FeatureRequestService.createFeatureRequest(data);
      if (response.success && state.modal.source === SOURCE_FEATURE_REQUEST_TABLE) {
        dispatch('getTableData')
      }
      return response;
    },
    async updateFeatureRequest({commit, state}, obj) {
      let response = await FeatureRequestService.updateFeatureRequest(obj.uuid, obj, '');
      if (response.success && state.modal.source === SOURCE_FEATURE_REQUEST_TABLE) {
        commit('updateFeatureRequest', response.body);
      }
      return response;
    },
    async removeFeatureRequest({dispatch}, item) {
      let response = await FeatureRequestService.removeFeatureRequest(item.uuid);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    onCommentCreated({state}, featureRequestUuid) {
      const index = state.tableData[state.tableSource].rows.findIndex(r => r.uuid === featureRequestUuid);
      state.tableData[state.tableSource].rows[index].total_comments += 1
    }
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: state => state.modal.show = false,
    showCommentsModal: (state, {featureRequest, source}) => {
      state.commentsModal.show = true;
      state.commentsModal.featureRequest = cloneDeep(featureRequest);
      state.commentsModal.source = source;
    },
    hideCommentsModal: state => {
      state.commentsModal.show = false
      state.commentsModal.featureRequest = null
      state.commentsModal.source = null
    },
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateFeatureRequest: (state, item) => {
      const index = state.tableData[state.tableSource].rows.findIndex(r => r.uuid === item.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...item};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  }
}
